// Lodash-free replacement for the `map-values-deep` package, which pulled
// the full lodash library into the bundle. Behaviour mirrors the original:
// arrays and plain objects are traversed, other objects are kept as is,
// primitives are passed to `fn(value, key)`.

const isPlainObject = (value) => {
  if (
    value === null
    || typeof value !== 'object'
    || Object.prototype.toString.call(value) !== '[object Object]'
  ) {
    return false;
  }

  const proto = Object.getPrototypeOf(value);

  return proto === null || (
    Object.prototype.hasOwnProperty.call(proto, 'constructor')
    && proto.constructor === Object
  );
};

const isObject = (value) => value !== null
  && (typeof value === 'object' || typeof value === 'function');

export default function mapValuesDeep(obj, fn, key) {
  if (Array.isArray(obj)) {
    const result = new Array(obj.length);

    for (let idx = 0; idx < obj.length; idx += 1) {
      result[idx] = mapValuesDeep(obj[idx], fn, idx);
    }

    return result;
  }

  if (isPlainObject(obj)) {
    const result = {};

    Object.keys(obj).forEach((innerKey) => {
      result[innerKey] = mapValuesDeep(obj[innerKey], fn, innerKey);
    });

    return result;
  }

  if (isObject(obj)) {
    return obj;
  }

  return fn(obj, key);
}
